//import 'react-app-polyfill/ie11';
import 'styles/app.css';
//import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
  </BrowserRouter>,
  rootElement);

let config = {  
    source: 'Selfcare',
    onSuccess: function (registration) { 
        console.log('index.js onSuccess...', registration);
         
         
    },
    onUpdate: function (registration) {
        console.log('index.js onUpdate...', registration);
        window.selfcareRegistration = registration;
        //alert('New version is available');
        //window.location.reload();
    //    if (window.updateAvailable) {
    //        window.updateAvailable();
    //    }
    }
};

//serviceWorker.register(config);

if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    window.document.addEventListener('touchmove', e => {
        if (e.scale !== 1) {
            e.preventDefault();
        }
    }, { passive: false });
}
